import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export const useSnakeStore = create()(
  persist(
    devtools((set) => ({
      highest: 0,
    })),
    {
      name: "snake-store",
    }
  )
);
